<template>
  <div id="applicationsList">
    <div class="d-flex justify-content-between">
      <h4>Applications</h4>
      <b-button variant="outline-secondary" size="sm" v-b-modal.createApplication>
        <b-icon icon="plus"/>
      </b-button>
    </div>
    

    <div class="d-flex justify-content-center mt-3" v-if="applicationsIsLoad">
      <b-spinner variant="primary" type="grow"/>
      <b-spinner variant="primary" type="grow"/>
      <b-spinner variant="primary" type="grow"/>
    </div>

    <b-list-group class="mt-3">
      <b-list-group-item
        v-for="(application,i) in applications"
        v-bind:key="i"
        button
        :active="activeApplication==application.id"
        @click="selectApplication(application.id)"
      >
        {{application.name}}
      </b-list-group-item>
    </b-list-group>

    <b-modal 
      id="createApplication"
      title="Create application"
      :ok-title="'Create'"
      @ok="createApplication"
    >
      <b-form-group
        id="name"
        label="Application name"
        label-for="name"
      >
        <b-form-input id="name" v-model="newApplication.name"></b-form-input>
      </b-form-group>

      <b-form-group
        id="OS"
        label="Application OS"
        label-for="OS"
      >
        <b-form-input id="OS" v-model="newApplication.OS"></b-form-input>
      </b-form-group>

      <b-form-group
        id="package_name"
        label="Application package_name"
        label-for="package_name"
      >
        <b-form-input id="package_name" v-model="newApplication.package_name"></b-form-input>
      </b-form-group>
      
    </b-modal>

  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'applicationsList',
  props:{
    company:{
      type:Object,
      required:true,
    },
    activeApplication:{
      default:null,
    }
  },
  data:function(){
    return {
      applicationCreateIsLoad:false,
      applicationsIsLoad:false,
      newApplication:{},
      applications:[],
    }
  },
  methods:{
    setEmptyApplicationData(){
      this.newApplication = {
        name:'',
        OS:'',
        package_name:'',
      }
    },
    createApplication(bvModalEvt){

      bvModalEvt.preventDefault();//Prevent modal from closing

      if(this.applicationCreateIsLoad){
        return false;
      }
      this.applicationCreateIsLoad = true;

      let data = this.newApplication;
      data.date = new Date();
      data.company = firebase.firestore().collection("companies").doc(this.company.id)

      firebase.firestore()
      .collection('applications').add(data)
      .then((applicationRef)=>{
        //add application to company
        data.id = applicationRef.id;

        return firebase.firestore()
        .collection("companies").doc(this.company.id)
        .update({
          applications:firebase.firestore.FieldValue.arrayUnion(applicationRef)
        })
      })
      .then(()=>{
        this.applications.push({
          id:data.id,
          name:data.name
        });
        this.selectApplication(data.id)
        this.applicationCreateIsLoad = false;
        this.$bvModal.hide('createApplication');
        this.setEmptyApplicationData();
      })
      .catch((error)=>{
        console.error("Error adding document: ", error);
      });
    },
    selectApplication(id){
      this.$emit('selectApplication',id);
    }
  },
  watch:{
    company:{
      handler:function(newVal,oldVal) {
        if(oldVal && newVal.id == oldVal.id || !this.company.data().applications){
          return;
        }
        let promises = [];
        this.applications = [];
        this.applicationsIsLoad = true;

        this.company.data().applications.forEach((doc)=>{
          promises.push(doc.get());
        })

        Promise.all(promises).then(results => {
          results.forEach((application) => {
            this.applications.push({
              id:application.id,
              name:application.data().name
            })
          });
          this.applicationsIsLoad = false;
        })
      },
      immediate: true,
    },
  },
  mounted(){
    this.setEmptyApplicationData()
  }
}
</script>